module.exports = __webpack_public_path__ + "img/fr-2.a3bba2ef.png";